import { NextPageRoute } from '@cvx/nextpage';
import { RoleGuard } from '../app/role-guard';
import { DelegationofauthorityComponent } from './modules/delegationofauthority/delegationofauthority.component';
import { TemporaryredelegationComponent } from './modules/temporaryredelegation/temporaryredelegation.component';
import { NonCnlEmployeesComponent } from './modules/administrator/non-cnl-employees/non-cnl-employees.component';
import { DoaSubCategoriesComponent } from './modules/administrator/doa-sub-categories/doa-sub-categories.component';
import { DoaTypesComponent } from './modules/administrator/doa-types/doa-types.component';
import { UsdConversionRateComponent } from './modules/administrator/usd-conversion-rate/usd-conversion-rate.component';
import { EmployeesDoaSetupComponent } from './modules/administrator/employees-doa-setup/employees-doa-setup.component';
import { DoaLogReportComponent } from './modules/administrator/doa-log-report/doa-log-report.component';
import { UsersSetupComponent } from './modules/administrator/users-setup/users-setup.component';
import { DoaCategoriesComponent } from './modules/administrator/doa-categories/doa-categories.component';
import { GetemployeesComponent } from './modules/delegationofauthority/getemployees/getemployees.component';
import { BydepartmentdivisionComponent } from './modules/delegationofauthority/bydepartmentdivision/bydepartmentdivision.component';
import { BydoatypeComponent } from './modules/delegationofauthority/bydoatype/bydoatype.component';
import { BydirectreportComponent } from './modules/delegationofauthority/bydirectreport/bydirectreport.component';
import { BycostcenterComponent } from './modules/delegationofauthority/bycostcenter/bycostcenter.component';
import { PrintpreviewComponent } from './modules/delegationofauthority/printpreview/printpreview.component';
import { AuthoritiesdefinitionsComponent } from './modules/delegationofauthority/authoritiesdefinitions/authoritiesdefinitions.component';
import { IssuesrememberindoaComponent } from './modules/delegationofauthority/issuesrememberindoa/issuesrememberindoa.component';
import { NotesComponent } from './modules/delegationofauthority/notes/notes.component';
import { ExecutionsignatureAuthorityComponent } from './modules/delegationofauthority/executionsignature-authority/executionsignature-authority.component';
import { HomeComponent } from './modules/permanentdelegation/home/home.component';
import { ManagedoatypesComponent } from './modules/permanentdelegation/managedoatypes/managedoatypes.component';
import { LogsComponent } from './modules/permanentdelegation/logs/logs.component';
import { DelegationComponent } from './modules/permanentdelegation/home/delegation/delegation.component';
import { SingledelegationComponent } from './modules/permanentdelegation/home/delegation/singledelegation/singledelegation.component';
import { MultipledelegationComponent } from './modules/permanentdelegation/home/delegation/multipledelegation/multipledelegation.component';
import { DisplaypageComponent } from './modules/delegationofauthority/displaypage/displaypage.component';
import { AuthGuardService } from './auth-guard.service';
import { UpdatenmaComponent } from './modules/delegationofauthority/updatenma/updatenma.component';
import { UpdatefscComponent } from './modules/delegationofauthority/updatefsc/updatefsc.component';
import { SearchredelegationComponent } from './modules/temporaryredelegation/searchredelegation/searchredelegation.component';
import { EnterredelegationComponent } from './modules/temporaryredelegation/enterredelegation/enterredelegation.component';
import { EditredelegationComponent } from './modules/temporaryredelegation/editredelegation/editredelegation.component';
import { EditorcancelredelegationComponent } from './modules/temporaryredelegation/editorcancelredelegation/editorcancelredelegation.component';
import { ReviewscreenComponent } from './modules/permanentdelegation/home/delegation/singledelegation/reviewscreen/reviewscreen.component';
import { SubmitscreenComponent } from './modules/permanentdelegation/home/delegation/singledelegation/reviewscreen/submitscreen/submitscreen.component';
import { PreviewReportComponent } from './modules/delegationofauthority/searchdoadatabase/previewreport/previewreport.component';
import { SearchdoadatabasereportComponent } from './modules/delegationofauthority/searchdoadatabasereport/searchdoadatabasereport.component';
import { ApproveredelegationComponent } from './modules/temporaryredelegation/approveredelegation/approveredelegation.component';
import { RedelegationComponent } from './modules/temporaryredelegation/redelegation/redelegation.component';
import { PayrolldownloadComponent } from './modules/temporaryredelegation/payrolldownload/payrolldownload.component';
import { CustomErrorPageComponent } from './shared/component/custom-error-page/custom-error-page.component';

export const routes: NextPageRoute[] = [
  {
    path: '',
    title: 'Default',
    redirectTo: '/DOA',
    pathMatch: 'full',
  },
  {
    path: 'TemporaryRedelegation',
    title: 'Temporary Re-Delegation',
    pathMatch: 'prefix',
    component: TemporaryredelegationComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        title: 'Delegation of Authority',
        component: DelegationofauthorityComponent,
      },
      {
        path: 'EnterReDelegation',
        title: 'Enter Re-Delegation',
        component: EnterredelegationComponent,
      },
      {
        path: 'EditReDelegation',
        title: 'Edit/Cancel Re-Delegation',
        component: EditredelegationComponent,
      },
      {
        path: 'EditCancelRedelegation',
        component: EditorcancelredelegationComponent,
      },
      {
        path: 'SearchRedelegation',
        title: 'Search Re-Delegation DB',
        component: SearchredelegationComponent,
      },
      {
        path: 'ApproveReDelegation',
        title: 'Approve Re-Delegation',
        component: ApproveredelegationComponent,
      },
      {
        path: 'Redelegation',
        component: RedelegationComponent,
      },

      {
        path: 'PayrollDownload',
        title: 'Payroll Download',
        component: PayrolldownloadComponent,
        canActivate: [AuthGuardService, RoleGuard],
        data: { expectedRoles: ['P', 'A', 'D'] },
      },
    ],
  },

  {
    path: 'DOA',
    title: 'Delegation of Authority',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        title: 'Delegation of Authority',
        component: DelegationofauthorityComponent,
      },
      {
        path: 'GetEmployeeDOA',
        title: "Get Employee's DOA",
        component: GetemployeesComponent,
      },
      // {
      //   path: 'Searchdoadatabase',
      //   title: "Search Doa Database",
      //   component: SearchdoadatabaseComponent,
      // },
      {
        path: 'Searchdoadatabase',
        title: 'Search DOA Database',
        component: SearchdoadatabasereportComponent,
      },
      {
        path: 'ByDepartmentDivision',
        title: 'List DOA By Department/Division',
        component: BydepartmentdivisionComponent,
      },
      {
        path: 'ByDOAType',
        title: 'List DOA By DOA Type',
        component: BydoatypeComponent,
      },
      {
        path: 'ByDirectReport',
        title: 'List DOA By Direct Report',
        component: BydirectreportComponent,
      },
      {
        path: 'ByCostCenter',
        title: 'List DOA By Cost Center',
        component: BycostcenterComponent,
      },
      {
        path: 'PrintPreview',
        component: PrintpreviewComponent,
      },
      {
        path: 'AuthoritiesDefinitions',
        component: AuthoritiesdefinitionsComponent,
      },
      {
        path: 'IssuesRememberinDOA',
        component: IssuesrememberindoaComponent,
      },
      {
        path: 'Notes',
        component: NotesComponent,
      },
      {
        path: 'ExecutionSignatureAuthority',
        component: ExecutionsignatureAuthorityComponent,
      },
      {
        path: 'DisplayPage',
        component: DisplaypageComponent,
      },
      {
        path: 'Updatenma',
        component: UpdatenmaComponent,
      },
      {
        path: 'Updatefsc',
        component: UpdatefscComponent,
      },
      {
        path: 'PreviewReport',
        title: 'Preview Report',
        component: PreviewReportComponent,
        canActivate: [AuthGuardService],
      },
    ],
  },
  {
    path: 'PermanentDelegation',
    title: 'Permanent Delegation',
    pathMatch: 'prefix',
    canActivate: [AuthGuardService],
    children: [
       {
        path: '',
        title: 'Delegation of Authority',
        component: DelegationofauthorityComponent,
      },
      {
        path: 'home',
        title: 'Enter Permanent Delegation',
        children: [
          {
            path: '',
            title: 'home',
            component: HomeComponent,
          },
          {
            path: 'delegation',
            title: 'delegation',
            children: [
              {
                path: '',
                title: 'delegation',
                component: DelegationComponent,
              },
              {
                path: 'singledelegation',
                title: 'single delegation',
                children: [
                  {
                    path: '',
                    title: 'single delegation',
                    component: SingledelegationComponent,
                  },
                  {
                    path: 'reviewscreen',
                    title: 'Review screen',
                    children: [
                      {
                        path: '',
                        title: 'Review screen',
                        component: ReviewscreenComponent,
                      },
                      {
                        path: 'submitscreen',
                        title: 'Submit screen',
                        component: SubmitscreenComponent,
                      },
                    ],
                  },
                ],
              },
              {
                path: 'multipledelegation',
                title: 'multiple delegation',
                component: MultipledelegationComponent,
              },
            ],
          },
        ],
      },
      {
        path: 'managedoatypes',
        title: 'Manage Doa Types',
        component: ManagedoatypesComponent,
        canActivate: [AuthGuardService, RoleGuard],
        data: { expectedRoles: ['A', 'D'] },
      },
      {
        path: 'logs',
        title: 'Logs',
        component: LogsComponent,
        canActivate: [AuthGuardService, RoleGuard],
        data: { expectedRoles: ['A', 'D'] },
      },
    ],
  },
  {
    path: 'Administrator',
    title: 'Administrators',
    pathMatch: 'prefix',
    canActivate: [AuthGuardService, RoleGuard],
    data: { expectedRoles: ['A', 'U', 'D'] },
    children: [
      {
        path: 'UsersSetup',
        title: 'Users Setup',
        component: UsersSetupComponent,
        canActivate: [AuthGuardService, RoleGuard],
        data: { expectedRoles: ['A', 'D'] },
      },
      {
        path: 'NonCnlEmployees',
        title: 'Non CNL Employees',
        component: NonCnlEmployeesComponent,
      },
      {
        path: 'DoaCategories',
        title: 'DOA Categories',
        component: DoaCategoriesComponent,
      },
      {
        path: 'DoaSubCategories',
        title: 'DOA Sub Categories',
        component: DoaSubCategoriesComponent,
      },
      {
        path: 'DoaTypes',
        title: 'DOA Types',
        component: DoaTypesComponent,
      },
      {
        path: 'UsdConversionRate',
        title: 'USD Conversion Rate',
        component: UsdConversionRateComponent,
      },
      {
        path: 'EmployeesDoaSetup',
        title: 'Employees DOA Setup',
        component: EmployeesDoaSetupComponent,
      },
      {
        path: 'DoaLogReport',
        title: 'DOA Log Report',
        component: DoaLogReportComponent,
      },
    ],
  },
  {
    path: 'error',
    component: CustomErrorPageComponent,
  },
];
